import { Routes, RouterModule } from '@angular/router';
import { IssuesExtListComponent } from './issues-ext-list/issues-ext-list.component';
import { ShellGuard } from '../shell/shell.guard';
import { IssueExtDetailsComponent } from './issues-ext-details/issue-ext-details/issue-ext-details.component';

const routes: Routes = [
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: 'active', component: IssuesExtListComponent,  data: {issueState: 'active'}},
    { path: 'myactive', component: IssuesExtListComponent, canActivate: [ShellGuard],  data: {issueState: 'myactive'}},
    { path: 'finished', component: IssuesExtListComponent, canActivate: [ShellGuard],  data: {issueState: 'finished'}},
    { path: 'myfinished',component: IssuesExtListComponent, canActivate: [ShellGuard],  data: {issueState: 'myfinished'}},
    { path: 'all', component: IssuesExtListComponent, canActivate: [ShellGuard],  data: {issueState: 'all'}},
    { path: ':state/issuedetails/:name', component: IssueExtDetailsComponent},
    { path: ':state/issuedetails/:name/:id', component: IssueExtDetailsComponent}
  ];

  export const IssuesExtRouting = RouterModule.forChild(routes);